import React from 'react';
import { useTranslation } from 'react-i18next';
import { RotateCcw } from 'lucide-react';
import { CardFooter } from '../ui/card';
import { Button } from '../ui/button';

interface NotificationResetFooterProps {
  onReset: () => void;
  isResetting?: boolean;
  testId: string;
}

/** Card footer with the "reset to default" action shared by every card. */
export const NotificationResetFooter: React.FC<NotificationResetFooterProps> = ({
  onReset,
  isResetting,
  testId,
}) => {
  const { t } = useTranslation('admin');

  return (
    <CardFooter className="justify-end">
      <Button
        variant="outline"
        size="sm"
        onClick={onReset}
        disabled={isResetting}
        data-testid={testId}
      >
        <RotateCcw className={`h-4 w-4 mr-2 ${isResetting ? 'animate-spin' : ''}`} />
        {isResetting ? t('notificationTemplates.resetting') : t('notificationTemplates.reset')}
      </Button>
    </CardFooter>
  );
};
